import React, { useState } from "react";
import { toast } from "react-toastify";
import { makeStyles, alpha } from "@material-ui/core/styles";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles((theme) => ({
  paper: { borderRadius: 16 },
  title: { paddingBottom: 4, "& h2": { fontWeight: 600 } },
  strong: { color: theme.palette.text.primary, fontWeight: 600 },
  callout: {
    display: "flex",
    gap: theme.spacing(1.25),
    alignItems: "flex-start",
    marginTop: theme.spacing(2),
    padding: theme.spacing(1.25, 1.5),
    borderRadius: 10,
    fontSize: 13,
    lineHeight: 1.45,
    backgroundColor: alpha(theme.palette.warning.main, 0.12),
    color: theme.palette.text.primary,
  },
  actions: { padding: theme.spacing(1.5, 3, 2.5), gap: theme.spacing(1), flexWrap: "wrap" },
  button: { textTransform: "none", fontWeight: 600, borderRadius: 10 },
  danger: {
    backgroundColor: theme.palette.error.main,
    color: "#fff",
    "&:hover": { backgroundColor: theme.palette.error.dark },
  },
}));

const listNames = (names) =>
  names.length <= 1 ? names.join("") : `${names.slice(0, -1).join(", ")} e ${names[names.length - 1]}`;

// Confirmação de exclusão que avisa quais filas ficam sem integração.
const IntegrationDeleteDialog = ({ integration, onClose, onDeleted }) => {
  const classes = useStyles();
  const [busy, setBusy] = useState(false);
  const queues = (integration && integration.queues) || [];

  const handleDelete = async () => {
    setBusy(true);
    try {
      await api.delete(`/queueIntegration/${integration.id}`);
      toast.success("Integração excluída.");
      onDeleted(integration.id);
    } catch (err) {
      toastError(err);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog
      open={Boolean(integration)}
      onClose={busy ? undefined : onClose}
      maxWidth="xs"
      fullWidth
      classes={{ paper: classes.paper }}
    >
      <DialogTitle className={classes.title}>Excluir integração?</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary">
          <span className={classes.strong}>{integration && integration.name}</span> será excluída. Essa
          ação não pode ser desfeita.
        </Typography>
        {queues.length > 0 && (
          <div className={classes.callout}>
            <InfoOutlinedIcon fontSize="small" style={{ marginTop: 1 }} />
            <span>
              {queues.length === 1 ? "Ela está na fila " : "Ela está nas filas "}
              <b>{listNames(queues.map((q) => q.name))}</b>.{" "}
              {queues.length === 1 ? "Essa fila vai ficar" : "Essas filas vão ficar"} sem integração, e as
              conversas novas não passam mais pelo robô.
            </span>
          </div>
        )}
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button onClick={onClose} disabled={busy} variant="outlined" className={classes.button}>
          Cancelar
        </Button>
        <Button
          onClick={handleDelete}
          disabled={busy}
          variant="contained"
          disableElevation
          className={`${classes.button} ${classes.danger}`}
        >
          {busy ? <CircularProgress size={18} color="inherit" /> : "Excluir"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IntegrationDeleteDialog;
